export default {"src":"/_next/static/media/caretup.b5389ac4.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};